import { useMemo } from "react";
import { motion } from "framer-motion";
import { usePresenceStore } from "../../stores/presence";
import { cn } from "../../lib/cn";

interface ActivityIndicatorProps {
  sectionId: string;
  className?: string;
}

function ActivityIndicator({ sectionId, className }: ActivityIndicatorProps) {
  const peers = usePresenceStore((s) => s.peers);
  const { count, avgVelocity } = useMemo(() => {
    let c = 0;
    let totalVelocity = 0;
    peers.forEach((peer) => {
      if (peer.sectionId === sectionId && peer.isActive) {
        c++;
        totalVelocity += peer.typingVelocity;
      }
    });
    return { count: c, avgVelocity: c > 0 ? totalVelocity / c : 0 };
  }, [peers, sectionId]);

  if (count === 0) return null;

  const intensity = Math.min(0.15, 0.03 + count * 0.03 + (avgVelocity / 300) * 0.05);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: intensity }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className={cn(
        "pointer-events-none absolute inset-0 rounded-[var(--radius-sm)]",
        "bg-[var(--color-lever-orange)]",
        className,
      )}
      aria-hidden
    />
  );
}

ActivityIndicator.displayName = "ActivityIndicator";

export { ActivityIndicator };
export type { ActivityIndicatorProps };
